import React from "react";
import { Header, Logo, Text } from "./Header.styled";

const HeaderComponent = ({ Icon, text, notIncludeHeight }) => {
  return (
    <>
      <div
        style={{
          position: "relative",
          height: notIncludeHeight ? "" : "100%",
          padding: "5px 0px 0px 10px",
        }}
      >
        <Header>
          <Logo>
            <Icon />
          </Logo>
          <Text>{text}</Text>
        </Header>
      </div>
    </>
  );
};

export default HeaderComponent;
